// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetFireDepartmentListRequestModel from '../../model/get-fire-department-list-request-model';
import GetFireDepartmentByIdRequestModel from '../../model/get-fire-department-by-id-request-model';
import GetLookupFireDepartmentRequestModel from '../../model/get-lookup-fire-department-request-model';
import FireDepartmentListResultModel from '../../model/fire-department-list-result-model';
import FireDepartmentModel from '../../model/fire-department-model';
import Int64LookupListResultModel from '../../model/int64-lookup-list-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getFireDepartmentList(request: GetFireDepartmentListRequestModel, config?: RequestConfig) {
    const requestDTO = GetFireDepartmentListRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-fire-department-list'] ?? 'FireDepartments';
    const response = await service.get<any>(endpointPath, {
      query: {
        userId: requestDTO.userId,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(FireDepartmentListResultModel.toModel(dto));
  },
  /**  */
  async getFireDepartmentById(request: GetFireDepartmentByIdRequestModel, config?: RequestConfig) {
    const requestDTO = GetFireDepartmentByIdRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-fire-department-by-id'] ?? 'FireDepartments/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(FireDepartmentModel.toModel(dto));
  },
  /**  */
  async getLookupFireDepartment(request: GetLookupFireDepartmentRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-lookup-fire-department'] ?? 'FireDepartments/Lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Int64LookupListResultModel.toModel(dto));
  },
});
